import { createContext } from 'react';

import { emptyAnchorLinkContext } from '@trqk/hooks';

export const AnchorLinksContext = createContext<AnchorLinksProviderValue>(
    emptyAnchorLinkContext,
);
